<template>
    <div>
        <div>
            <b-form-select v-model="selected" :options="options" class="select"></b-form-select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'range',
    updated: function(){
        this.$emit('sendRange', this.selected)
    },
    data: function(){
        return {
            selected: '',
            options: [
                {value: '', disabled: true, text: 'Wybierz zasięg'},
                {value: 'Zasięg: Lokalny', text: 'Zasięg: Lokalny'},
                {value: 'Zasięg: Partnerzy', text: 'Zasięg: Partnerzy'},
                {value: 'Zasięg: Zewnętrzny', text: 'Zasięg: Zewnętrzny'},
                {value: 'Zasięg: Globalny', text: 'Zasięg: Globalny'},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .select {
        margin-bottom: 10px;
    }
</style>